import React, { useState } from "react";
import { CompanyBusinessHoursPostDTO } from "definitions/Company";
import { Weekdays } from "definitions/Others";
import { translate } from "translate/i18n";
import { postRequest } from "utils/request";
import { Calendar } from "primereact/calendar";
import { Translations } from "definitions/Locale";
import { isArray } from "lodash";
import { toast } from "react-toastify";

const weekdaysList = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

async function create(dtos: CompanyBusinessHoursPostDTO[]) {
  const result = postRequest(
    "/companiesbusinesshours",
    dtos.map((dto) => ({
      ...dto,
      startTime: dto.startTime.toString().split(" ")[4].substring(0, 5),
      endTime: dto.endTime.toString().split(" ")[4].substring(0, 5),
    }))
  );
  return result;
}

type WeekdayCheckboxProps = {
  value: Weekdays;
  translationKey: keyof Translations;
  onChangeHandler: React.ChangeEventHandler<HTMLInputElement>;
  fontSize: string;
};
function WeekdayCheckbox(props: WeekdayCheckboxProps) {
  const { onChangeHandler, translationKey, value, fontSize } = props;
  return (
    <div className="checkbox-container">
      <input
        value={value}
        onChange={onChangeHandler}
        type="checkbox"
        className="checkbox"
      />
      <span
        style={{
          marginRight: 5,
          marginLeft: 5,
          fontSize,
          wordBreak: "keep-all",
          whiteSpace: "nowrap",
        }}
      >
        {translate(translationKey)}
      </span>
    </div>
  );
}

// @ts-ignore
type NewBusinessHoursProps = {
  daysAlreadySavedInDB: number[];
  CompanyDepartmentId: number;
  toggleCreationMode: (choice: boolean) => void;
  triggerReactivity: () => void;
};
export function NewBusinessHours(props: NewBusinessHoursProps) {
  const {
    daysAlreadySavedInDB,
    CompanyDepartmentId,
    toggleCreationMode,
    triggerReactivity,
  } = props;

  const [weekdays, setWeekdays] = useState<number[]>([]);
  const [startTime, setStartTime] = useState<Date | Date[]>(
    new Date("2024-01-01T08:00")
  );
  const [endTime, setEndTime] = useState<Date | Date[]>(
    new Date("2024-01-01T18:00")
  );

  const handleWeekdaySelection = (day: number, checked: boolean) => {
    if (!checked) {
      setWeekdays((prev) => prev.filter((d) => d !== day));
      return;
    }
    if (checked && !weekdays.includes(day)) {
      setWeekdays((prev) => [...prev, day]);
    }
  };

  const handleSaveNewDays = () => {
    if (!startTime || !endTime) return;
    create(
      weekdays.map((weekday) => ({
        CompanyDepartmentId,
        day: weekday,
        startTime,
        endTime,
      }))
    ).then((result) => {
      if (result.success) {
        toggleCreationMode(false);
        triggerReactivity();
      } else {
        console.log("result", result);
      }
    });
  };

  return (
    <div className="card p-2 mt-3">
      <h5 className="pl-0 mb-1 card-title">
        {translate("newBusinessHourTitle")}:
      </h5>
      <div className="card-body d-flex mt-0 pb-1 pt-0 pl-0" style={{ gap: 10 }}>
        <Calendar
          value={startTime}
          onChange={(e) => {
            const date = isArray(e.value) ? e.value[0] : e.value;
            if (date && endTime && +date < +endTime) {
              setStartTime(date);
            } else {
              toast.info(translate("warningStartTimeGreaterThanEndTime"));
            }
          }}
          timeOnly
          style={{ maxWidth: 100 }}
        />
        <Calendar
          value={endTime}
          onChange={(e) => {
            const date = isArray(e.value) ? e.value[0] : e.value;
            if (date && +date > +startTime) {
              setEndTime(date);
            } else {
              toast.info(translate("warningEndTimeLessThanStartTime"));
            }
          }}
          timeOnly
          style={{ maxWidth: 100 }}
        />
        <div className="d-flex">
          {weekdaysList
            .filter(
              (weekday) => !daysAlreadySavedInDB.includes(Weekdays[weekday])
            )
            .map((weekday) => (
              <WeekdayCheckbox
                translationKey={weekday as keyof Translations}
                key={weekday}
                value={Weekdays[weekday]}
                onChangeHandler={(evt) => {
                  handleWeekdaySelection(
                    Number(evt.target.value),
                    evt.target.checked
                  );
                }}
                fontSize={daysAlreadySavedInDB.length ? "16px" : "14px"}
              />
            ))}
        </div>
        <button className="btn btn-info lead mr-2" onClick={handleSaveNewDays}>
          {translate("save")}
        </button>
        <button
          className="btn btn-warning lead"
          onClick={() => {
            toggleCreationMode(false);
          }}
        >
          {translate("cancel")}
        </button>
      </div>
    </div>
  );
}
